import React from 'react';

const TennisEventsModal = ({
  matches, getDate, getTime,
}) => (
  <table className="event-selection">
    <thead>
      <tr>
        <th>Time</th>
        <th>Player 1</th>
        <th>Player 2</th>
        <th>Competition</th>
        <th>Tournament ID</th>
        <th>Round</th>
      </tr>
    </thead>
    <tbody>
      {matches.map((event) => (
        <tr key={event.matchId}>
          <td>
            {getDate(event.startDateTime)}
            <span className="m-l-10">{getTime(event.startDateTime)}</span>
          </td>
          <td>{event.playerOne}</td>
          <td>{event.playerTwo}</td>
          <td>{event.competition}</td>
          <td>{event.tournamentId}</td>
          <td>{event.round}</td>
        </tr>
      ))}

    </tbody>
  </table>
);

export default TennisEventsModal;
